// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-noMargin-text-25d102dc"};